export default "__VITE_ASSET__DRxQ2wIX__"